export const LOADER_COMPETENCY_QUESTIONS          =       'LOADER_COMPETENCY_QUESTIONS';
export const GET_COMPETENCY_QUESTIONS             =       'GET_COMPETENCY_QUESTIONS';
export const COMPETENCY_QUESTIONS_FALLA           =       'COMPETENCY_QUESTIONS_FALLA';
export const SAVE_LOADER_COMPETENCY_QUESTIONS     =       'SAVE_LOADER_COMPETENCY_QUESTIONS';
export const FORM_COMPETENCY_QUESTIONS_FAIL       =       'FORM_COMPETENCY_QUESTIONS_FAIL';

